import { api } from './apiSlice'

export const listingsApiSlice = api.injectEndpoints({
    endpoints: build => ({
        generateRedemptionToken: build.mutation({
            query: partnerListingId => ({
                url: `/partners/listings/${partnerListingId}/generate-redemption-token`,
                method: 'POST',
                body: {},
            }),
        }),
    }),
})

export const { useGenerateRedemptionTokenMutation } = listingsApiSlice
